// extracted by mini-css-extract-plugin
export var popper = "_7r-0";